import axios from 'axios'
import { useQuery } from 'react-query'

import { ROSTER_API_PATH } from 'config/app.config'
import { RosterResponse } from 'types/roster.types'

// src/setupProxy.js is only read when the dev server starts, so a server started before a route
// was added serves index.html in its place
class MissingRouteError extends Error {
  constructor() {
    super(`${ROSTER_API_PATH} is not being served: restart the dev server (pnpm dev)`)
  }
}

// The roster comes from recruit-next and its photos from TA Draft, both through this app's own
// endpoint, which signs the requests server-side (api/_lib/recruitApi.js)
const fetchRoster = async (): Promise<RosterResponse> => {
  let res
  try {
    res = await axios.get<RosterResponse>(ROSTER_API_PATH)
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) throw new MissingRouteError()
    throw error
  }

  // The dev server answers an unknown path with a 404, or index.html, so check the shape too
  if (!Array.isArray(res.data?.tutors)) throw new MissingRouteError()
  return res.data
}

export const useRoster = () => {
  return useQuery<RosterResponse, Error>('roster', fetchRoster, {
    // Retrying cannot fix a missing route; say so at once instead of sitting on "loading"
    retry: (failureCount, error) => !(error instanceof MissingRouteError) && failureCount < 3,
  })
}
